import { render, staticRenderFns } from "./EasyMoneyBoard.vue?vue&type=template&id=f15a1f7a&scoped=true&"
import script from "./EasyMoneyBoard.vue?vue&type=script&lang=js&"
export * from "./EasyMoneyBoard.vue?vue&type=script&lang=js&"
import style0 from "./EasyMoneyBoard.vue?vue&type=style&index=0&id=f15a1f7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15a1f7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VFlex,VImg,VRow})
